import { render, staticRenderFns } from "./applyforhelp.vue?vue&type=template&id=07e0a606&scoped=true&"
import script from "./applyforhelp.vue?vue&type=script&lang=js&"
export * from "./applyforhelp.vue?vue&type=script&lang=js&"
import style0 from "./applyforhelp.vue?vue&type=style&index=0&id=07e0a606&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e0a606",
  null
  
)

export default component.exports